/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис работы с доступами к камерам
 */

/**
 * Тип субъекта доступа
 */
export enum CameraAccessAccessorType {
  /**
   * Значение не указно
   */
  ACCESSOR_TYPE_UNKNOWN = "ACCESSOR_TYPE_UNKNOWN",
  /**
   * Пользователь
   */
  USER = "USER",
  /**
   * ГРуппа
   */
  GROUP = "GROUP",
}
/**
 * Тип субъекта доступа
 */
export type CameraAccessAccessorTypeResponseEnum = keyof typeof CameraAccessAccessorType
/**
 * Тип субъекта доступа
 */
export type CameraAccessAccessorTypeRequestEnum = Exclude<CameraAccessAccessorTypeResponseEnum, "ACCESSOR_TYPE_UNKNOWN">;

/**
 * Доступ к камере.
 * # Описание модели
 */
export type CameraAccessRequestDto = {
  /**
   * Идентификатор камеры в vcfront.
   * # Тип: Guid
   */
  externalId: string
  /**
   * Тип субъекта доступа
   */
  accessorType: CameraAccessAccessorTypeRequestEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
  /**
   * Идентификатор компании в vcfront.
   * # Диапазон: 1..2147483647
   */
  vcCompanyId: number
}
/**
 * Доступ к камере.
 * # Описание модели
 */
export type CameraAccessResponseDto = {
  /**
   * Идентификатор камеры в vcfront.
   * # Тип: Guid
   */
  externalId: string
  /**
   * Тип субъекта доступа
   */
  accessorType: CameraAccessAccessorTypeResponseEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
  /**
   * Идентификатор компании в vcfront.
   * # Диапазон: 1..2147483647
   */
  vcCompanyId: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Доступ к камере.
   * # Описание модели
   */
  "CameraAccess": {
    "kind": "class",
    "text": "Доступ к камере.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор камеры в vcfront.
       * # Тип: Guid
       */
      "externalId": {
        "type": "string",
        "text": "Идентификатор камеры в vcfront.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип субъекта доступа
       */
      "accessorType": {
        "type": "CameraAccess.AccessorType",
        "text": "Тип субъекта доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор субъекта доступа.
       * # Диапазон: 1..36
       */
      "accessorId": {
        "type": "string",
        "text": "Идентификатор субъекта доступа.\n# Диапазон: 1..36",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 36,
            "message": "Значение не входит в допустимый диапазон. Максимум: 36"
          },
        }
      },
      /**
       * Идентификатор компании в vcfront.
       * # Диапазон: 1..2147483647
       */
      "vcCompanyId": {
        "type": "int32",
        "text": "Идентификатор компании в vcfront.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Тип субъекта доступа
   */
  "CameraAccess.AccessorType": {
    "kind": "enum",
    "text": "Тип субъекта доступа",
    "values": {
      /**
       * Значение не указно
       */
      "ACCESSOR_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указно",
      },
      /**
       * Пользователь
       */
      "USER": {
        "i": 1,
        "text": "Пользователь",
      },
      /**
       * ГРуппа
       */
      "GROUP": {
        "i": 2,
        "text": "ГРуппа",
      },
    },
  },
}